import { render, staticRenderFns } from "./survey-settings-tab.vue?vue&type=template&id=453f4be2&"
import script from "./survey-settings-tab.vue?vue&type=script&lang=js&"
export * from "./survey-settings-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453f4be2')) {
      api.createRecord('453f4be2', component.options)
    } else {
      api.reload('453f4be2', component.options)
    }
    module.hot.accept("./survey-settings-tab.vue?vue&type=template&id=453f4be2&", function () {
      api.rerender('453f4be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/survey-settings-tab.vue"
export default component.exports